/** Canonical training record edit contract. Never save a requirement code as a record ID. */
export const getTrainingRecordId = (record) =>
  String(record?.record_id || record?.id || '').trim();

export const prefillTrainingEdit = (saved, matrixRow = {}) => ({
  ...saved,
  // Existing canonical fields win. Matrix projection is a fallback for older
  // source-backed records; it never silently replaces the persisted evidence.
  title: saved?.raw_course_title || saved?.training_name || matrixRow?.title || '',
  completed_at: saved?.completion_date || saved?.completed_at || matrixRow?.completed_at || '',
  expires_at: saved?.expiry_date || saved?.expires_at || matrixRow?.expires_at || '',
  provider: saved?.provider_name || saved?.provider || matrixRow?.provider || '',
  certificate_number: saved?.certificate_number || matrixRow?.certificate_number || '',
});

export const buildTrainingEditPayload = (record, noExpiry) => ({
  completion_date: String(record?.completed_at || '').slice(0, 10),
  expiry_date: noExpiry ? null : String(record?.expires_at || '').slice(0, 10),
  provider_name: String(record?.provider || '').trim() || null,
  certificate_number: String(record?.certificate_number || '').trim() || null,
  reason: 'Admin corrected an existing training record',
});
